import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LogsComponent } from './logs/logs.component';
import { LogRoutingModule } from './log-routing.module';
import { MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule } from "@angular/material";
import { OaInsightModule } from "../open-age-ng/insight/oa-insight.module";
import { LogViewComponent } from "./log-view/log-view.component";

/**  Pages*/

@NgModule({
  declarations: [
    LogsComponent,
    LogViewComponent
  ],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    LogRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    OaInsightModule
  ],
  entryComponents: [],
})
export class LogModule { }
